import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import autoTable from 'jspdf-autotable';
import jsPDF from "jspdf";
import moment from "moment";
import React, { useState, useEffect } from 'react'

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";

import { callAddFontNirmalaBold } from '../../../styles/fonts/Nirmala-bold';
import { callAddFontNirmalaNormal } from '../../../styles/fonts/Nirmala-normal';
import { excelConfig, filterHeaderXlStyle, filterHeaderXlDataStyle } from '../../../configs/excelConfig';
import { fetchApi } from '../../../services/apiService';
import { hasAccess, NumberFormatter, jsPdfHeaderFooter, jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from '../../../components/generics/helper';
import { Loader } from '../../../components/generics/Loader';
import { REPORT_TABLE_PAGINATION_ROWS_OPTIONS, EXPORT_PER_REQUEST_RECORD_LIMIT, REPORT_TABLE_PAGINATION_ROWS_OPTIONS_SELECTED } from "../../../constants/commonConstants";
import { StyledTableRow, StyledTableCell } from "../../../components/Table/TableStyle";
import CommonTableHeaderRow from '../../../components/Table/CommonTableHeaderRow';
import CommonTablePagination from '../../../components/Table/CommonTablePagination';
import excelExport from '../../../services/exports/export-excel';

const nowrapCellStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

const ItemIssueRegisterReportDetailList = (props) => {
    const { itemIssueReportFilters, loadData, setLoadData } = props
    const { enqueueSnackbar } = useSnackbar();

    const userToken = useSelector((state) => state.login.userToken);
    const { selectedRolesRights = [], adminType = 0 } = useSelector((state) => state.login?.userData);
    const userData = useSelector((state) => state.login.userData);

    const [isPdfLoading, setIsPdfLoading] = useState(false);
    const [isPdfLoaded, setIsPdfLoaded] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageNo, setPageNo] = useState(0);
    const [perPageRecords, setPerPageRecords] = useState(REPORT_TABLE_PAGINATION_ROWS_OPTIONS_SELECTED);

    const getIIRSearchParams = (page = 1, perPage = EXPORT_PER_REQUEST_RECORD_LIMIT) => {
        let IIRSearchParams = {}

        if (itemIssueReportFilters?.searchCategoryIds !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchItemCategoryIds: itemIssueReportFilters.searchCategoryIds };
        }
        if (itemIssueReportFilters?.searchSubCategoryIds !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchItemSubCategoryIds: itemIssueReportFilters.searchSubCategoryIds };
        }
        if (itemIssueReportFilters?.searchBrandIds !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchItemBrandIds: itemIssueReportFilters.searchBrandIds };
        }
        if (itemIssueReportFilters?.searchItemIds !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchItemIds: itemIssueReportFilters.searchItemIds };
        }
        if (itemIssueReportFilters?.searchVehBrandId !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchVehicleOemIds: itemIssueReportFilters.searchVehBrandId };
        }
        if (itemIssueReportFilters?.searchVehModelId !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchVehicleModelIds: itemIssueReportFilters.searchVehModelId };
        }
        if (itemIssueReportFilters?.searchVehId !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchVehicleIds: itemIssueReportFilters.searchVehId };
        }
        if (itemIssueReportFilters?.searchStoreIds !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchStoreIds: itemIssueReportFilters.searchStoreIds };
        }
        if (itemIssueReportFilters?.searchReportingView !== '') {
            IIRSearchParams = { ...IIRSearchParams, searchReportingView: itemIssueReportFilters.searchReportingView };
        }
        IIRSearchParams.showOnlyPurchaseItems = itemIssueReportFilters.showOnlyPurchaseItems;
        IIRSearchParams.pageNo = page;
        IIRSearchParams.perPageRecords = perPage;
        IIRSearchParams.formattedDate = "Y";
        IIRSearchParams.searchReportingView = 'D';
        IIRSearchParams.dateType = itemIssueReportFilters.dateType;
        if (itemIssueReportFilters.dateType === 'J') {
            IIRSearchParams.fromDate = moment(itemIssueReportFilters?.fromDate).format('YYYY-MM-DD');
            IIRSearchParams.toDate = moment(itemIssueReportFilters?.toDate).format('YYYY-MM-DD');
        } else {
            IIRSearchParams.fromDate = moment(itemIssueReportFilters?.fromDate).format('YYYY-MM-DD');
            IIRSearchParams.toDate = moment(itemIssueReportFilters?.toDate).format('YYYY-MM-DD');
        }

        return IIRSearchParams;
    };

    const generateItemIssueReportData = async (page = 0, rowsPerPage = perPageRecords) => {
        setIsLoading(true);
        try {
            const diffDays = moment(itemIssueReportFilters.toDate).diff(moment(itemIssueReportFilters.fromDate), 'days');
            if (diffDays > 90) {
                enqueueSnackbar('Date range cannot exceed 90 days', { variant: 'error' });
                setIsLoading(false);
                return;
            }
            const IIRSearchParams = getIIRSearchParams(page + 1, rowsPerPage);

            const response = await fetchApi('reports/getIssueItemsRegisterReportData', IIRSearchParams, userToken);
            setIsLoading(false);

            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                if (response.data.issueRegisterDetailViewData.length > 0) {
                    enqueueSnackbar('Item Issue Report Detail Data Loaded Successfully', { variant: 'success', key: Date.now() });
                    setTableData(response?.data?.issueRegisterDetailViewData);
                    setTotalRecords(response.data.totalRecords);
                } else {
                    enqueueSnackbar('Ooops! No Record Found', { variant: 'error' });
                    setTableData([]);
                }
            } else {
                enqueueSnackbar(response.errorMessage, { variant: 'error' });
                setTableData([]);
                setTotalRecords(0);
            }
        } catch (err) {
            let message = 'Item Issue Detail Report List Loading Failed';
            if (!err.message) {
                err.message = message
            }
            enqueueSnackbar(err.message, { variant: 'error' });
            setTableData([])
            setTotalRecords(0);
            return { data: [], totalRecords: 0 };
        } finally {
            setLoadData(false);
        }
    }
    const exportAllItemIssueDetailData = async () => {
        const allIIRData = [];
        try {
            const IIRSearchParams = getIIRSearchParams(itemIssueReportFilters);
            const totalPages = Math.ceil(totalRecords / IIRSearchParams.perPageRecords);
            for (let page = 1; page <= totalPages; page++) {
                const pageParams = { ...IIRSearchParams, pageNo: page };
                const response = await fetchApi('reports/getIssueItemsRegisterReportData', pageParams, userToken);
                if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                    allIIRData.push(...response.data.issueRegisterDetailViewData);
                }
            }
            return allIIRData;
        } catch (err) {
            let message = 'Item Issue Report Detail List Export Failed';
            if (!err.message) {
                err.message = message
            }
            enqueueSnackbar(err.message, { variant: 'error' });
            return [];
        }
    }

    const handleChangePage = (event, newPage) => {
        setPageNo(newPage);
        generateItemIssueReportData(newPage, perPageRecords);
    };
    const handleChangeRowsPerPage = (event) => {
        setPerPageRecords(parseInt(event.target.value, 10));
        setPageNo(0);
        generateItemIssueReportData(0, parseInt(event.target.value, 10));
    };
    const columnDefs = [
        { headerName: 'Jobcard Date', pdfHead: 'Jobcard Date', xlCol: { dataType: 'string', dataFormatter: null, width: 15 }, field: 'jobCardDate', headerSx: { width: '130px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Time', pdfHead: 'Time', xlCol: { dataType: 'string', dataFormatter: null, width: 15 }, field: itemIssueReportFilters.dateType === 'J' ? 'jobCardTime' : 'issueTime', headerSx: { width: '130px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Issue Date', pdfHead: 'Issue Date', xlCol: { dataType: 'string', dataFormatter: null, width: 15 }, field: 'issueDate', headerSx: { width: '130px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Category', pdfHead: 'Category', field: 'categoryTitle', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Subcategory', pdfHead: 'Sub cat', field: 'subCategoryTitle', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '150px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Brand', pdfHead: 'Brand', field: 'brandName', xlCol: { dataType: 'string', dataFormatter: null, width: 15 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Item Name', pdfHead: 'Item Name', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, field: 'itemName', headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Issue QTY', pdfHead: 'Issue QTY', field: 'qty', xlCol: { dataType: 'quantity', dataFormatter: null, width: 15 }, headerSx: { width: '100px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Serial No', pdfHead: 'Serial No', field: 'serialNo', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, headerSx: { width: '100px', textAlign: "left" }, allowSorting: false, },
        { headerName: 'Position', pdfHead: 'Position', field: 'position', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, headerSx: { width: '90px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Amount', pdfHead: 'Amt', field: 'amount', xlCol: { dataType: 'currency', dataFormatter: null, width: 15 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Vehicle No.', pdfHead: 'Vehicle No. ', field: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null, width: 35 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Vehicle Code', pdfHead: 'Vehicle Code. ', field: 'vehicleCode', xlCol: { dataType: 'string', dataFormatter: null, width: 35 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },       
        { headerName: 'Job Card No.', pdfHead: 'Job Card No. ', field: 'jobCardNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Issue Store', pdfHead: 'Issue Store', xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, field: 'issueStoreName', headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Issue By', pdfHead: 'Issue By', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, field: 'issuedByName', headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Remark', pdfHead: 'Remark', xlCol: { dataType: 'string', dataFormatter: null, width: 50 }, field: 'remark', headerSx: { width: '150px', textAlign: "left" }, allowSorting: false },
    ];

    const getFilterSectionData = () => {
        return {
            filterHeaderXlStyle,
            filterHeaderXlDataStyle,
            filterData: [
                {
                    columns: [
                        { header: 'Filter Date Type', dataKey: 'filterDateType', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: itemIssueReportFilters.dateType === 'J' ? 'Jobcard From Date' : 'Issue From Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: itemIssueReportFilters.dateType === 'J' ? 'Jobcard To Date' : 'Issue To Date', dataKey: 'toDate', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Category', dataKey: 'categoryTitle', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Subcategory', dataKey: 'subCategoryTitle', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Brand', dataKey: 'brandName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                    ],
                    pdfColumnStyles: {
                        0: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        1: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        2: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        3: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        4: { cellWidth: 45, halign: 'left', fontSize: 10 },
                        5: { cellWidth: 40, halign: 'left', fontSize: 10 },
                    },
                    data: [
                        {
                            filterDateType: itemIssueReportFilters.dateType === 'J' ? 'Jobcard Date' : 'Issue Date',
                            fromDate: moment(itemIssueReportFilters.fromDate).format('DD-MMM-YY'),
                            toDate: moment(itemIssueReportFilters.toDate).format('DD-MMM-YY'),
                            categoryTitle: itemIssueReportFilters.searchCategoryIds === "" ? 'All Categories' : itemIssueReportFilters.searchCategoryIds.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchCategoryIds.split(',').length} ]` : (itemIssueReportFilters?.searchCategoryNames || [])[0],
                            subCategoryTitle: itemIssueReportFilters.searchSubCategoryIds === "" ? 'All Sub Categories' : itemIssueReportFilters.searchSubCategoryIds.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchSubCategoryIds.split(',').length} ]` : (itemIssueReportFilters?.searchSubCategoryNames || [])[0],
                            brandName: itemIssueReportFilters.searchBrandIds === "" ? 'All Brands' : itemIssueReportFilters.searchBrandIds.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchBrandIds.split(',').length} ]` : (itemIssueReportFilters?.searchBrandNames || [])[0],

                        }
                    ]
                },
                {
                    columns: [
                        { header: 'Items', dataKey: 'itemName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Bus OEM', dataKey: 'vehicleOemName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Bus Model', dataKey: 'vehicleModelName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Bus No', dataKey: 'vehicleNoWithCode', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Issue By store', dataKey: 'issueStoreName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Report Type', dataKey: 'reportFor', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },

                    ],
                    pdfColumnStyles: {
                        0: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        1: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        2: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        3: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        4: { cellWidth: 45, halign: 'left', fontSize: 10 },
                        5: { cellWidth: 40, halign: 'left', fontSize: 10 },
                    },
                    data: [
                        {
                            itemName: itemIssueReportFilters.searchItemIds === "" ? 'All Items' : itemIssueReportFilters.searchItemIds.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchItemIds.split(',').length} ]` : itemIssueReportFilters?.searchItemNames[0],
                            vehicleOemName: itemIssueReportFilters.searchVehBrandId === "" ? 'All Vehicle OEM' : itemIssueReportFilters.searchVehBrandId.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchVehBrandId.split(',').length} ]` : itemIssueReportFilters?.searchVehBrandName[0],
                            vehicleModelName: itemIssueReportFilters.searchVehModelId === "" ? 'All Vehicle Models' : itemIssueReportFilters.searchVehModelId.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchVehModelId.split(',').length} ]` : itemIssueReportFilters?.searchVehModelName[0],
                            vehicleNoWithCode: itemIssueReportFilters.searchVehId === "" ? 'All Vehicle No.' : itemIssueReportFilters.searchVehId.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchVehId.split(',').length} ]` : itemIssueReportFilters?.searchVehNo[0],
                            issueStoreName: itemIssueReportFilters.searchStoreIds === "" ? 'All Stores' : itemIssueReportFilters.searchStoreIds.split(',').length > 1 ? `Multiple [ ${itemIssueReportFilters.searchStoreIds.split(',').length} ]` : (itemIssueReportFilters?.searchStoreNames || [])[0],
                            reportFor: itemIssueReportFilters.searchReportViewName,
                        }
                    ]
                },
            ]
        }
    }

    const printReport = async () => {
        try {
            const filterSectionData = getFilterSectionData();
            setIsPdfLoading(true);
            setIsPdfLoaded(false);
            const pdfColumns = columnDefs.map((col) => {
                return { header: col.pdfHead, dataKey: col.field, xlCol: col.xlCol }
            });

            const fullData = await exportAllItemIssueDetailData();

            jsPDF.API.events.push(["addFonts", callAddFontNirmalaBold]);
            jsPDF.API.events.push(["addFonts", callAddFontNirmalaNormal]);
            const doc = new jsPDF({
                orientation: 'l',
                format: 'a4',
                compress: true,
            });
            var totalPagesExp = '{total_pages_count_string}';
            doc.autoTableSetDefaults({
                headStyles: { fontSize: 6, halign: 'left', fillColor: [30, 89, 167] },
            });
            doc.setProperties({
                title: `itemIssueRegisterDetailReport-${moment().format('DD-MMM-YY-HH-mm')}.pdf`,
                subject: "Item Issue Register Report Detail View",
                author: "Maven Tech Labs Pvt. Ltd.",
                keywords: "maven tech, Maintenance system, item issue register",
                creator: "MTLPL",
            });
            autoTable(doc, {
                margin: { top: 16, left: 5, right: 5, bottom: 5 },
                columns: filterSectionData.filterData[0].columns,
                body: filterSectionData.filterData[0].data,
                columnStyles: filterSectionData.filterData[0].pdfColumnStyles,
                theme: 'grid',
                tableWidth: 'wrap',
            });
            autoTable(doc, {
                startY: doc.lastAutoTable.finalY,
                margin: { top: 16, left: 5, right: 5, bottom: 5 },
                columns: filterSectionData.filterData[1].columns,
                body: filterSectionData.filterData[1].data,
                columnStyles: filterSectionData.filterData[1].pdfColumnStyles,
                theme: 'grid',
                tableWidth: 'wrap',
            });
            doc.line(0, doc.lastAutoTable.finalY + 2, doc.getPageWidth(), doc.lastAutoTable.finalY + 2);
            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 4,
                tableWidth: 'auto',
                margin: { top: 2, left: 5, right: 5, bottom: 5 },
                alternateRowStyles: {
                    fillColor: [255, 255, 255]
                },
                columns: pdfColumns,
                body: fullData,
                columnStyles: {
                    0: { minCellWidth: 10 },
                    1: { minCellWidth: 10 },
                    2: { minCellWidth: 15 },
                    3: { minCellWidth: 15 },
                    4: { minCellWidth: 15 },
                    5: { minCellWidth: 15 },
                    6: { minCellWidth: 18, overflow: 'linebreak' },
                    7: { minCellWidth: 12, halign: 'right' },
                    8: { minCellWidth: 15 },
                    9: { minCellWidth: 15 },
                    10: { minCellWidth: 12, halign: 'right' },
                    11: { minCellWidth: 16 },
                    12: { minCellWidth: 16 },
                    13: { minCellWidth: 16 },
                    14: { minCellWidth: 10 },
                    15: { minCellWidth: 10 },
                    16: { minCellWidth: 30 },
                },
                theme: 'grid',
                bodyStyles: {
                    fontSize: 6,
                    halign: 'left',
                },
                didParseCell: (data) => {
                    jsPdfDidParseCellCallback(data, pdfColumns,);
                },
                willDrawCell: (data) => {
                    jsPdfWillDrawCellCallback(data);
                },
                didDrawPage: function (data) {
                    data.settings.margin.top = 16;
                    const reportTitle = `Maintenance System | Item Issue Register Details Report`;
                    jsPdfHeaderFooter(data, reportTitle, userData, totalPagesExp);
                },
            },
            );
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            setIsPdfLoaded(true);
            setTimeout(() => {
                // document.getElementById('output').data = doc.output('datauristring', `itemIssueRegisterDetails_${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.pdf`);
                const blob = doc.output('blob');
                const url = URL.createObjectURL(blob);
                document.getElementById('output').data = url;
                setIsPdfLoading(false);
            }, 1000);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
            setIsPdfLoaded(false);
        }
    }

    const reportExcelExport = async () => {
        try {
            const filterSectionData = getFilterSectionData();
            setIsPdfLoading(true);
            const xlColumns = columnDefs.map((col) => {
                return { colHeader: col.headerName, field: col.field, xlCol: col.xlCol }
            });
            const reportTitle = `Maintenance System | ${itemIssueReportFilters.searchReportViewName} Item Issue Register Report`
            const xlConfig = {
                ...excelConfig,
                columns: xlColumns,
                fileName: `Item_Issue_Details_Report_${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.xlsx`,
                showFilterSection: true,
                filterSectionData,
                workSheetTitle: `Item_Issue_Register_Report`,
                headerFooter: {
                    firstHeader: `&L&14&K104FA2 ${reportTitle} &R&B&12 Company Name: ${userData.companyName}`,
                    firstFooter: `&L&12 Report By : ${userData.userFullName}  [ ${userData.branchName} ] &C&12 Report Time :  ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")} &R&12 Page: &P of &N`
                },
                sheetHeaderData: [{
                    "caption": "Report Name :",
                    "value": `${itemIssueReportFilters.searchReportViewName} - Item Issue Register Report`,
                    "colSpan": 7
                }, {
                    "caption": "Company Name :",
                    "value": userData.companyName,
                    "colSpan": 6
                }],
            };
            const fullData = await exportAllItemIssueDetailData();
            await excelExport.processExcel(xlConfig, fullData);
            setIsPdfLoading(false);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
        }
    }

    const backToScreenView = () => {
        setIsPdfLoaded(false);
    }

    useEffect(() => {
        if (loadData) {
            generateItemIssueReportData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadData]);

    return (
        <>
            <React.Fragment key="iir">
                {isLoading && <div style={{ width: "100%", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
                {tableData.length > 0 &&
                    <React.Fragment key="iir_dataBlock">
                        <div className='report--header--container'>
                            <div className='report--for--heading'>Report View : {itemIssueReportFilters.searchReportViewName}</div>
                            <div key="iir_report_action_container" className="report-export-button--container">
                                {!isPdfLoaded && <React.Fragment key="iir_Actions">
                                    {hasAccess(selectedRolesRights, '4112', adminType) && <div key="iir_xls_btn" className="dashed--btn" onClick={() => reportExcelExport()}> EXPORT AS EXCEL </div>}
                                    {hasAccess(selectedRolesRights, '4113', adminType) && <div key="iir_pdf_btn" className="dashed--btn" onClick={() => printReport()}> EXPORT AS PDF </div>}
                                    {hasAccess(selectedRolesRights, '4111', adminType) && <div key="iir_prn_btn" className="dashed--btn" onClick={() => printReport()}> PRINT </div>}
                                </React.Fragment>}
                                {isPdfLoaded && <React.Fragment key="iir_backBtn"><div key="iir_back_btn" className="dashed--btn" onClick={() => backToScreenView()}> Back </div> </React.Fragment>}
                                {isPdfLoading && <div key="iir_loading_container" style={{ width: "100px", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
                            </div>
                        </div>
                        {!isPdfLoaded && <React.Fragment key="iir_dataTable">
                            <div className="table--container">
                                <TableContainer component={Paper} className="jc--scroll" style={{ maxHeight: '85vh' }}>
                                    <Table sx={{ minWidth: 1500 }} stickyHeader aria-label="sticky table">
                                        <CommonTableHeaderRow columnDefs={columnDefs} />
                                        <TableBody>
                                            {tableData && tableData.length ? tableData.map((row, index) => (
                                                row.isDataRow ?
                                                    <StyledTableRow key={`${row.rowType}-D-${index}`} className="grid">
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.jobCardDate}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}> {itemIssueReportFilters.dateType === 'J' ? row.jobCardTime : row.issueTime}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.issueDate}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.categoryTitle}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.subCategoryTitle}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.brandName}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.itemName}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.qty > 0 ? NumberFormatter(row.qty, 3) : ' '}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.serialNo}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.position}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{NumberFormatter(row.amount, 2)}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.vehicleNo || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.vehicleCode || ''}</StyledTableCell>                                                       
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.jobCardNo || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.issueStoreName || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.issuedByName || ''}</StyledTableCell>
                                                        <StyledTableCell style={{ ...nowrapCellStyle }}>{row.remark || ''}</StyledTableCell>
                                                    </StyledTableRow>
                                                    : null
                                                // row.isTotalRow &&
                                                // <StyledTableRow key={`${row.rowType}-T-${index}`} style={{ background: "#e4ebf5" }} className="grid">
                                                //     <StyledTableCell colSpan={row.colSpan} style={{ width: "50px", textAlign: "left", fontWeight: "700" }}>{row.totalCaption}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "100px", textAlign: "right" }}>{row.qty > 0 ? NumberFormatter(row.qty, 2) : ' '}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "103px", textAlign: "right" }}>{row.receivedQty > 0 ? NumberFormatter(row.receivedQty, 2) : ' '}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "100px", textAlign: "right" }}>{NumberFormatter(row.balanceQty, 2)}</StyledTableCell>
                                                //     <StyledTableCell style={{ width: "120px", textAlign: "right", fontWeight: "700" }}>{NumberFormatter(row.grossAmount, 2)}</StyledTableCell>
                                                // </StyledTableRow>
                                            )) :
                                                <StyledTableRow key={`$iir_no_records_row`}>
                                                    <StyledTableCell style={{ width: "100%" }} colSpan={columnDefs.length} align="center">
                                                        <div key="iir_no_records" className='no--records'> No Records </div>
                                                    </StyledTableCell>
                                                </StyledTableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className="report-pagination--container">
                                <CommonTablePagination
                                    rowsPerPageOption={REPORT_TABLE_PAGINATION_ROWS_OPTIONS}
                                    count={totalRecords}
                                    rowsPerPage={perPageRecords}
                                    className=""
                                    page={pageNo}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </div>
                        </React.Fragment>}
                        {isPdfLoaded && <object id="output" type="application/pdf" width="100%" height="600" title="MTLPL - Maintenance System - Item Issue Register Report" aria-label="MTLPL - Maintenance System - Item Issue Register Report"></object>}
                    </React.Fragment>
                }
            </React.Fragment>
        </>
    );
}
export default ItemIssueRegisterReportDetailList;